import LogoDarkSvg from '@/app-theme/assets/img/logo/logo-dark.svg?no-inline'
import LogoLightSvg from '@/app-theme/assets/img/logo/logo-light.svg?no-inline'

import LogoDarkPng from '@/app-theme/assets/img/logo/logo-dark.png?no-inline'
import LogoLightPng from '@/app-theme/assets/img/logo/logo-light.png?no-inline'

import LogoMp from '@/app-theme/assets/img/logo/logo-mp-viva.png?no-inline'

export default {
  name    : 'Env',
  computed: {
    LogoDarkSvg() {
      return LogoDarkSvg
    },
    LogoDarkPng() {
      return LogoDarkPng
    },
    LogoLightSvg() {
      return LogoLightSvg
    },
    LogoLightPng() {
      return LogoLightPng
    },
    LogoMp() {
      return LogoMp
    },
    LogoViva() {
      return '/img/logo/logo-viva.png'
    }
  }
}
